import * as toastr from "toastr";
import { ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';

import * as events from '../Bus/Bus';
import { ContactListConfig, ICAMSContact } from '../Contacts/ContactsModels';

export class Entity_LandContact {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openLandContactLinkPanel = (landCode: string, contactRef: string, contactType: string, isNewContact: Boolean, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Land/LandContactLink', { landCode: landCode, contactRef: contactRef, contactType: contactType }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal('#landEditContactModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#landEditContactModal"));

            $('#landEditContact_contactSearch').on('click', function (evt) {
                Utilities.GetModal('#landEditContactModal', ModalAction.Hide);

                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, contactCallback]));

                function contactCallback(contacts: Array<ICAMSContact>) {
                    Utilities.GetModal('#landEditContactModal', ModalAction.Show);

                    if (contacts == null || contacts.length == 0) {
                        return;
                    }

                    $('#landEditContactForm [name="ContactRef"]').val(contacts[0].ContactRef);
                    $('#landEditContactForm [name="ContactRefListName"]').val(contacts[0].ListName);
                }
            });

            $('#landEditContactSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#landEditContactForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#landEditContactModal .modal-content"));
                let formData = new FormData(<any>$('#landEditContactForm')[0]);
                var url = isNewContact == true ? '/Land/CreateContactLink' : '/Land/UpdateContactLink';
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: url,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#landEditContactModal', ModalAction.Hide);
                                callback();
                            }
                            else {
                                let msg: string = 'Failed to edit contact!';
                                if (result.message) msg = result.message;
                                toastr.error(msg);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            Utilities.GetModal('#landEditContactModal', ModalAction.Hide);
                        }
                        finally {
                            Utilities.UnBlockUI($("#landEditContactModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#landEditContactDeleteBtn').on('click', function (evt) {
                evt.preventDefault();

                Utilities.BlockUI($("#landEditContactModal .modal-content"));
                let formData = new FormData(<any>$('#landEditContactForm')[0]);
                var url = isNewContact == true ? '/Land/DeleteContactLink' : '/Land/UpdateContactLink';
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Land/DeleteContactLink',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#landEditContactModal', ModalAction.Hide);
                                callback();
                            }
                            else {
                                toastr.error('Failed to delete contact!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            Utilities.GetModal('#landEditContactModal', ModalAction.Hide);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#landEditContactCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#landEditContactModal', ModalAction.Hide);
                callback();
            });

            $('#landEditContactCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#landEditContactModal', ModalAction.Hide);
                callback();
            });
        });
    }

    public addLandContact = (data: ICAMSKey, callback: Function): void => {
        // Open the contacts list view
        let btns = new ContactListConfig();
        btns.ActionBtns.account.visible = false;
        btns.ActionBtns.export.visible = false;
        btns.ActionBtns.query.visible = false;
        btns.ActionBtns.viewprint.visible = false;
        btns.AllowMultipleSelection = false;
        events.bus.publish(events.eventOpenContactsListView([false, btns, contactCallback]));

        function contactCallback(contacts: Array<ICAMSContact>) {
            if (contacts == null || contacts.length == 0) {
                callback();
                return;
            }

            var contactData = { contactRef: contacts[0].ContactRef, landCode: data.code };
            Utilities.BlockUI();
            $.ajax({
                type: "POST",
                url: '/Land/AddContact',
                data: contactData,
                success: function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            toastr.info('Added contact!');
                        }
                        else {
                            toastr.error('Failed to add contact!');
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        callback();
                        Utilities.UnBlockUI();
                    }
                }
            }).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }
}




